import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Layout, Space, Typography } from 'antd'

const { Footer } = Layout
const { Text } = Typography

export const LayoutFooter: React.FC = () => {
  const year = new Date().getFullYear()
  const navigate = useNavigate()

  return (
    <Footer style={{ textAlign: 'center', backgroundColor: '#f8f8f2' }}>
      <Space direction="vertical">
        <Space direction="horizontal" wrap style={{ justifyContent: 'center' }}>
          <Button type="text" onClick={() => navigate('/legal-notice')}>
            <Text style={{ fontWeight: 300 }}>Mentions légales</Text>
          </Button>
          <Button type="text" onClick={() => navigate('/data-privacy')}>
            <Text style={{ fontWeight: 300 }}>
              Politique de confidentialité
            </Text>
          </Button>
        </Space>
        <Text style={{ fontWeight: 300 }}>
          © {year}{' '}
          <Link type="text" to={'https://supplement-bacon.com'} target="_blank">
            <Text>Supplément Bacon</Text>
          </Link>
        </Text>
      </Space>
    </Footer>
  )
}
